export default __webpack_public_path__ + "static/media/Mark-5-HUD-Altimeter.a4f7e03d.jpg";